import React from "react";
import { Row, Col, Button } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import RenderAddButton from "./RenderAddButton";

const AddSubSection = ({
  dragToggle,
  addButtonVisible,
  addButtonStateChange,
  itemId,
  nestedIndex,
  index,
  addOption,
  addSubSection,
}) => {
  return (
    <>
      {!dragToggle && (
        <Row gutter={[16, 16]}>
          <Col span={8}></Col>
          <Col span={10}>
            {addButtonVisible ? (
              <Button
                type="primary"
                shape="circle"
                icon={<PlusOutlined />}
                onClick={() => {
                  nestedIndex !== undefined
                    ? addButtonStateChange(false, itemId, nestedIndex)
                    : addButtonStateChange(false, itemId);
                }}
              />
            ) : (
              <Button
                danger
                shape="circle"
                icon={<CloseOutlined />}
                onClick={() => {
                  nestedIndex !== undefined 
                    ? addButtonStateChange(true, itemId, nestedIndex)
                    : addButtonStateChange(true, itemId);
                }}
              />
            )}
          </Col>
          <Col span={6}></Col>
        </Row>
      )}
      {!dragToggle && !addButtonVisible && (
        <Row gutter={[16, 16]}>
          <Col span={6}></Col>
          <Col span={6}>
            {nestedIndex !== undefined ? (
              <RenderAddButton
                title={"Add Heading"}
                isHeading={true}
                id={itemId}
                childId={null}
                position={nestedIndex + 1}
                addOption={addOption}
                nestedIndex={nestedIndex}
                addSubSection={addSubSection}
              />
            ) : (
              // renderAddButton(
              //     "Add Heading",
              //     true,
              //     itemId,
              //     null,
              //     nestedIndex + 1
              //   )
              // renderAddButton("Add Heading", true, itemId, null, index + 1)
              <RenderAddButton
                title="Add Heading"
                isHeading={true}
                id={itemId}
                childId={null}
                position={index+1}
                addOption={addOption}
                addSubSection={addSubSection}
              />
            )}
          </Col>
          <Col span={6}>
            {nestedIndex !== undefined ? (
              // renderAddButton(
              //     "Add Item",
              //     false,
              //     itemId,
              //     null,
              //     nestedIndex + 1
              //   )
              <RenderAddButton
                title="Add Item"
                isHeading={false}
                id={itemId}
                childId={null}
                position={nestedIndex + 1}
                addOption={addOption}
                nestedIndex={nestedIndex}
                addSubSection={addSubSection}
              />
            ) : (
              // renderAddButton("Add Item", false, itemId, null, index + 1)
              <RenderAddButton
                title="Add Item"
                isHeading={false}
                id={itemId}
                childId={null}
                position={index + 1}
                addOption={addOption}
                addSubSection={addSubSection}
              />
            )}
          </Col>
          <Col span={6}></Col>
        </Row>
      )}
    </>
  );
};

export default AddSubSection;
